import router from '@/router'
import { startLoading, endLoading, endDomLoading } from '@/util/loading'
import helper from '@/util/signinHelper'
import store from '@/store'
import config from '@/config'
import { getCookies } from '@/util/cookies'
import redirect from '@/util/redirect'
import { sensorsBindLogin, sensorsTrack } from '@/util/sensorsdata'
import { parseSecureURL } from '@/util/secureURLUtils';
import { SENSORS_TRACK, URL_TO_TAB_NAME } from '@/util/sensorsdata/constant'

export default {
  authorize() {
    router.beforeEach(async (to, from, next) => {
      const registerToken = to.query.a
      const accessToken = to.query.accessToken  // 可能是cp ib  | 官网登录来的
      const cpPath = to.query.path
      const lang = to.query.lang
      const redirectUrl = to.query.redirectUrl

      if (lang) store.commit('common/setLang', lang)

      // ib 登出回到 cp 的 logout page
      if (to.path == '/logout') helper.signOut(null, 'manuallyTypeUrl')
      else if (accessToken) {
        try {
          const decryptPayload = await parseSecureURL(accessToken);
          helper.refreshToken(decryptPayload.accessToken, decryptPayload.pk, cpPath)
        } catch (error) {
          console.error('Failed to decrypt accessToken:', error.message);
          helper.signOut();
        }
      } else if (registerToken) {
        store.commit('common/setAuthHeaders', {
          etxId: '',
          eCode: '',
          ptxId: '',
          pCode: '',
          tCode: '',
        })
        helper.register(registerToken)
      }
      else if (store.state.common.loginStatus) {
        //  if login but doesn't have token, logout
        if (!getCookies('token')) helper.signOut(null, 'missingToken')
        sensorsBindLogin(store.state.common.userId, store.state.common.eventEmailId, store.state.common.eventMobileId)
        if (to.name == '/' || to.name == 'login' || to.name == 'to_login') {
          if (redirectUrl) {
            next(redirectUrl)
          } else {
            next('/home')
          }
        }
        if (to.meta.authority && to.meta.displayTitle && store.state.common.registerStep < 5) {
          store.commit('common/setFromPath', true)
          next('/authority')
        } else if (to.meta.authority && store.state.common.registerStep < 5) {
          store.commit('common/setFromPath', false)
          next('/authority')
        } else {
          if (
            to.name == 'depositFunds' &&
            config
              .restrictDepositFundsByCountries(store.state.common.regulator)
              .includes(parseInt(store.state.common.countryCode))
          )
            next('restrictDeposit')
          else {
            if (!to.meta.noShowLoading) startLoading('router')
            next()
          }
        }
      } else {
        // promotion added redirection config
        if (to.name == 'promotion') {
          redirect.redirectToLogoutUrl('?redirectUrl=' + to.fullPath)
        } else {
          to.meta.allowAnonymous ? next() : redirect.redirectToLogoutUrl()
        }
      }
    })
    router.afterEach((to, from) => {
      const inSensors = URL_TO_TAB_NAME[to.path]
      if (inSensors) {
        sensorsTrack(SENSORS_TRACK.EVENT_NAME.CRM_TABPAGE_VIEW, {
          tab_name: inSensors,
        })
      }
      endLoading()
      endDomLoading()
    })
  },
}
